import { useEffect, useState } from "react"
import { waitForPendingWrites } from "firebase/firestore"
import { firestoreDB } from "./firebase.service"
import { createSyncTracker } from "../utils/network.utils"

// Una sola sorveglianza per tutta l'app: la pastiglia che dice "offline" o
// "da inviare", l'avviso di versione nuova che prima di ricaricare aspetta
// le scritture, e le operazioni che si fanno contare. Come funziona sta in
// `createSyncTracker` (utils/network.utils.js).
export const syncTracker = createSyncTracker({
	waitForQueue: () => waitForPendingWrites(firestoreDB),
})

// Un'operazione che scrive su Firestore dopo aver aspettato il server — e
// che quindi, finché aspetta, in coda non c'è ancora — conta come modifica
// da inviare.
export const trackSync = promise => syncTracker.track(promise)

export const useSyncStatus = () => {
	const [status, setStatus] = useState(syncTracker.getState)

	useEffect(() => {
		syncTracker.start()
		setStatus(syncTracker.getState())
		return syncTracker.subscribe(setStatus)
	}, [])

	return status
}

// Aspetta che non ci sia più niente da mandare — né in coda, né in corso —
// ma non oltre `timeout`. Torna `true` se ci si è arrivati in tempo.
//
// Chi ricarica l'app per una versione nuova la usa prima di farlo: le
// scritture in coda sopravvivono al ricaricamento, ma le operazioni a metà
// — gli allievi di una lezione appena modificata, che partono dopo la
// lezione — no.
export const waitForSync = (timeout = 5000) =>
	Promise.race([
		syncTracker.whenIdle().then(() => true),
		new Promise(resolve => setTimeout(() => resolve(false), timeout)),
	])
